"use client";

import Image from "next/image";
import React, { useMemo, useState } from "react";
import { ReactSVG } from "react-svg";

import cn from "@/utils/cn";

import "./icon.css";

export interface IconProperties {
  className?: string;
  title?: string;
  description?: string;
  role?: string;
  size: "12" | "16" | "20" | "24" | "32" | "40" | "48" | "56" | "64" | "80" | "84";
  name: string;
  fill?: string;
  onClick?: () => void;
}

const Icon: React.FC<IconProperties> = ({ className, title, description, size, name, fill, ...props }) => {
  const [iconType, setIconType] = useState<string>("");
  const iconFile: string | null = useMemo(() => {
    if (name) {
      if (name.startsWith("https:")) {
        setIconType(name.split(".").pop() || "");
        return name;
      }
      const fileExt = name.split(".").pop();
      const base: string = `/icons/`;
      setIconType(fileExt || "");
      if (fileExt === "svg" || fileExt === "png") {
        return `${base}${name}`;
      } else {
        return `${base}${name}.svg`;
      }
    } else {
      console.error("No icon name provided!");
      return null;
    }
  }, [name]);
  if (!iconFile || !iconType) return <span>No icon file found!</span>;
  return iconType === "png" || (iconType === "svg" && iconFile?.startsWith("https")) ? (
    <Image src={iconFile!} width={`${size}`} height={`${size}`} aria-hidden={true} alt={name} />
  ) : (
    <ReactSVG
      // afterInjection={(svg) => {
      //   console.log(svg);
      // }}
      // loading={() => <span className="text-xs">Loading...</span>}
      // onClick={() => {
      //   console.log("wrapper onClick");
      // }}
      // onError={(error) => {
      //   console.error(error);
      // }}
      style={{ width: `${size}px`, height: `${size}px` }}
      beforeInjection={(svg) => {
        svg.classList.add("stroke-inherit");
        if (fill) svg.classList.add(fill);
        svg.setAttribute("style", `width: ${size}px; height: ${size}px`);
        svg.querySelectorAll("path").forEach((element) => {
          element.setAttribute("stroke", "inherit");
          element.setAttribute("stroke-width", "1.4");
        });
      }}
      desc={description}
      evalScripts="always"
      fallback={() => (
        <span className="text-xs text-center">
          <strong>{name}</strong>
        </span>
      )}
      httpRequestWithCredentials={true}
      renumerateIRIElements={false}
      src={`${iconFile}`}
      aria-label={title}
      useRequestCache={true}
      wrapper="span"
      className={cn(`leading-[0] svg-icon`, !!className ? className : "")}
      aria-hidden={true}
      {...props}
    />
  );
};

Icon.displayName = "Icon";

export default Icon;
